import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";

export const GET_ALL_INFO_SECTION_CATEGORIES = gql`
  query GetAllInfoSectionCategories {
    infoSectionCategories {
      description
      heading
      link
      urlText
      type {
        id
        name
      }
      position
      id

      subCategories {
        urlText
        id
        heading
        description
        position
        entries {
          id
          heading
          description
          url
          image {
            ...imageFields
          }
          position
        }
      }
    }
  },
  ${ImageFragment}
`;
